<template>
    <b-modal
        id="modal-add-card"
        title="Adicionar Método de Pagamento"
        @close="clearForm"
        no-close-on-backdrop
        static
        hide-footer>
        <b-overlay :show="loading" rounded="sm">
            <form @submit.stop.prevent="submit" class="row g-1">

                <!-- Errors -->
                <div v-if="Object.keys(errors).length > 0" class="col-md-12">
                    <div class="alert alert-danger pb-0">
                        <div v-for="(error, errorIdx) in Object.keys(errors)" :key="errorIdx">
                            <strong>
                                {{ findNameOfField(error) }}
                            </strong>
                            <div>
                                <ul>
                                    <li v-for="message in errors[error]" :key="message">
                                        {{ findErrorMessage(message) }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Holder Name -->
                <div class="col-md-12">
                    <b-form-group label="Nome">
                        <b-form-input
                            type="text"
                            name="holder-name"
                            v-model="form.holder_name"
                            placeholder="Insira o nome do titular do cartão"
                            required
                        />
                    </b-form-group>
                </div>

                <!-- Card Number -->
                <div class="col-md-12">
                    <b-form-group label="Número do Cartão">
                        <b-input-group>

                            <b-form-input
                                type="tel"
                                name="card-number"
                                v-model="form.number"
                                v-mask="'#### #### #### ####'"
                                placeholder="#### #### #### ####"
                                required
                                :state="hasErrors('request.card.number', errors)"
                            />

                            <template #append>
                                <b-input-group-text v-if="brand"><strong class="text-capitalize" >{{ brand }}</strong></b-input-group-text>
                            </template>
                        </b-input-group>
                    </b-form-group>
                    <has-errors :errors="errors" name='request.card.number' />
                </div>

                <!-- Card Exp Month -->
                <div class="col-md-6">
                    <b-form-group label="Mês de Expiração">
                        <b-form-select
                            name="card-exp-month"
                            v-model="form.exp_month"
                            :options="monthsOptions"
                            required>
                        </b-form-select>
                    </b-form-group>
                </div>

                <!-- Card Exp Year -->
                <div class="col-md-6">
                    <b-form-group label="Ano de Expiração">
                        <b-form-select
                            name="card-exp-year"
                            v-model="form.exp_year"
                            :options="yearsOptions"
                            required>
                        </b-form-select>
                    </b-form-group>
                </div>

                <!-- CVV -->
                <div class="col-md-12">
                    <b-form-group label="Código de Segurança">

                        <b-form-input
                            type="tel"
                            name="cvv"
                            v-model="form.cvv"
                            placeholder="Insira o código de segurança do seu cartão"
                            v-mask="['###', '####']"
                            required
                        />
                    </b-form-group>
                </div>

                <!-- Message Security -->
                <div class="col-md-12 text-success">
                    <div class="alert alert-success">
                        <div>
                            <img src="/img/pagarme.svg" class="mx-auto" alt="" height="55px" />
                        </div>
                        <div class="mt-3">
                            <span class="fas fa-lock mr-1"></span>
                            Esta página utiliza criptografia 256 bits para garantir a segurança dos seus dados de pagamento.
                        </div>
                    </div>
                </div>

                <!-- Submit -->
                <div class="col-md-12">
                    <b-form-group>
                        <b-button
                            type="submit"
                            variant="primary"
                            block
                            :disabled="loading"
                        >
                            Adicionar Método de Pagamento
                        </b-button>
                    </b-form-group>
                </div>


            </form>
        </b-overlay>
    </b-modal>
</template>

<script>
import errorsTranslate from './mixins/errorsTranslate';
import cardValidations from './mixins/cardValidations';
export default {
    mixins:[errorsTranslate, cardValidations],
    props: {
        pagarmeKey: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            loading: false,
            errors: {},
            form: {
                holder_name: null,
                number: null,
                exp_month: null,
                exp_year: null,
                cvv: null,
            },
            brand: null,
            yearsOptions: this.generateYearsOptions(),
            monthsOptions: [
                { value: 1, text: 'Janeiro - 01' },
                { value: 2, text: 'Fevereiro - 02' },
                { value: 3, text: 'Março - 03' },
                { value: 4, text: 'Abril - 04' },
                { value: 5, text: 'Maio - 05' },
                { value: 6, text: 'Junho - 06' },
                { value: 7, text: 'Julho - 07' },
                { value: 8, text: 'Agosto - 08' },
                { value: 9, text: 'Setembro - 09' },
                { value: 10, text: 'Outubro - 10' },
                { value: 11, text: 'Novembro - 11' },
                { value: 12, text: 'Dezembro - 12' },
            ]
        }
    },
    watch: {

        'form.number'() {

            this.errors = {};
            if(this.form.number.length > 13){
                if(!this.isValidCardNumber(this.form.number)){
                    this.errors = { 'request.card.number': ['Número de cartão inválido']};
                }
                this.brand = this.getBrand(this.form.number);
            }

        }
    },
    methods: {
        async submit() {
            this.loading = true;

            const response = await fetch('https://api.pagar.me/core/v5/tokens?appId=' + this.pagarmeKey, {
                method: 'POST',
                headers: {
                    accept: 'application/json',
                    'content-type': 'application/json'
                },
                body: JSON.stringify({
                    card: {
                        holder_name: this.form.holder_name,
                        number: this.form.number ? this.form.number.replace(/\s/g, '') : null,
                        exp_month: this.form.exp_month,
                        exp_year: this.form.exp_year,
                        cvv: this.form.cvv,
                    },
                    type: 'card'
                })
            });

            let data = await response.json();

            if (response.status === 200) {

                await this.saveCardToCustomer(data);

            } else if (response.status === 422) {
                this.$toast.error('Ops! Verifique se os dados do cartão estão corretos.', {
                    duration: 5000,
                });

                this.errors = data.errors || {};
            }

            this.loading = false;
        },

        async saveCardToCustomer(information) {
            this.loading = true;

            await axios.post('/teacher/pagarme/card', {
                token: information.id,
                brand: information.card.brand,
                exp_month: information.card.exp_month,
                exp_year: information.card.exp_year,
                first_six_digits: information.card.first_six_digits,
                holder_name: information.card.holder_name,
                last_four_digits: information.card.last_four_digits,
            })
                .then((response) => {
                    this.$toast.success('Método de pagamento adicionado com sucesso!', {
                        duration: 5000,
                    });

                    this.$emit('added', response.data);

                    this.$bvModal.hide('modal-add-card');

                    this.clearForm();
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        generateYearsOptions() {
            const currentYear = new Date().getFullYear();
            const years = 20;
            const yearsOptions = [];

            for (let i = 0; i < years; i++) {
                yearsOptions.push(currentYear + i);
            }

            return yearsOptions;
        },

        findNameOfField(field) {
            const fields = {
                'request.card.holder_name': 'Nome do Cartão',
                'request.card.number': 'Número do Cartão',
                'request.card.exp_month': 'Mês de Expiração',
                'request.card.exp_year': 'Ano de Expiração',
                'request.card.cvv': 'Código de Segurança',
                'request.card': 'Cartão de Crédito',
                'request': 'Dados do Cartão'
            };

            return fields[field] || field;
        },

        clearForm() {
            this.form = {
                holder_name: null,
                number: null,
                exp_month: null,
                exp_year: null,
                cvv: null,
            };

            this.errors = {};
        },

    }
}
</script>

<style scoped>

</style>
